import React from "react";

export const useTmblTableData = <T>(data?: T[]): readonly T[] => {
  return React.useMemo<T[]>(() => data || [], [data]);
};
